var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C9.51562 0 5.2433 3.26786 0 8.57143C4.51339 13.1049 8.30357 17.1429 15 17.1429C21.6897 17.1429 26.6116 12.0268 30 8.66518C26.5312 4.72768 21.6161 0 15 0ZM15 14.6853C11.692 14.6853 9 11.9397 9 8.57143C9 5.19643 11.692 2.45759 15 2.45759C18.308 2.45759 21 5.20312 21 8.57143C21 11.9464 18.308 14.6853 15 14.6853Z",
    fill: "#A2A4A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 6.42854C14.9998 5.89952 15.194 5.41738 15.5087 5.04238C15.3413 5.01559 15.1739 5.0022 14.9998 5.0022C13.0712 5.0022 11.4976 6.60264 11.4976 8.57139C11.4976 10.5401 13.0712 12.1406 14.9998 12.1406C16.9284 12.1406 18.502 10.5401 18.502 8.57139C18.502 8.41738 18.4886 8.26336 18.4752 8.10934C18.1069 8.39729 17.6516 8.57139 17.1493 8.57139C15.9574 8.57139 14.9998 7.6138 14.9998 6.42854Z",
    fill: "#A2A4A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.37e8e734fe452577ee3579974093e1b6.svg";
export { ForwardRef as ReactComponent };